import {Slot, Text, Trail, Typography} from '@logistics-frontend/blocks'

import {StaticRequirementModel} from '../types'
import {classes} from './StaticRequirement.classes'

type Props = {
  requirement: StaticRequirementModel
}

export function StaticRequirement({requirement}: Props) {
  return (
    <Slot size="l">
      <Text className={classes.body}>
        <Typography thickness="regular" variant="body2">
          {requirement.title}
        </Typography>
        {requirement.description && (
          <Typography color="minor" variant="caption1">
            {requirement.description}
          </Typography>
        )}
      </Text>
      <Trail>
        <Typography color="minor" group="tight" variant="body2">
          {requirement.value ? 'Вкл.' : 'Выкл.'}
        </Typography>
      </Trail>
    </Slot>
  )
}
